


































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "../../root/modal";
import PlanCard from "./PlanCard.vue";
import { ref, computed, onMounted } from "@vue/composition-api";
import { SharedState } from "@/common/state";
import { CmsPricingPlan } from "@/common/state/cms/cms.models";
import Tabs from "./Tabs.vue";
import { startTrial } from "@/common/api/api";
import { editionToNumber } from "@/common/models";
import { AppAnalytics } from "@/analytics";
export default Vue.extend({
  components: {
    Modal,
    PlanCard,
    Tabs,
  },
  props: ["modalData"],
  setup(props) {
    const current_category = ref("Standard");

    const plans = computed(() =>
      SharedState.pricing_plans.value.map((plan) => {
        plan.is_on = SharedState.is_already_upgraded(plan.id);
        return plan;
      })
    );

    const current_solution_name = ref("");
    const solutions = computed(() =>
      plans.value.filter((p: CmsPricingPlan) => p.price.type === "seat")
    );

    const has_only_one_solution = computed(() => solutions.value.length === 1);
    const has_many_solutions = computed(() => !has_only_one_solution.value);

    const main_tabs = computed(() => {
      if (has_only_one_solution.value) {
        return ["Standard", solutions.value[0].name];
      } else {
        return ["Standard", "Solutions"];
      }
    });

    const current_solution = computed(() => {
      if (current_solution_name.value) {
        return solutions.value.filter(
          (s: CmsPricingPlan) => s.name === current_solution_name.value
        )[0];
      } else {
        return null;
      }
    });

    const config = computed(() => {
      return {
        title: "",
        desc: "",
        blank: true,
        width: "70rem", // 76
        height: current_category.value === "Standard" ? "54rem" : "58rem",
        backdropDismiss: true,
      } as ModalConfig;
    });

    const check_start_trial_on_init = () => {
      if (
        props.modalData &&
        //@ts-ignore
        props.modalData.action &&
        //@ts-ignore
        props.modalData.action === "start_trial"
      ) {
        start_the_trial();
      }
    };

    onMounted(() => {
      check_start_trial_on_init();
      const not_on_trial = !SharedState.loggedUser.value.trial.active;
      const is_entrprise =
        SharedState.loggedUser.value.paymentEdition.name === "enterprise";
      if (not_on_trial && is_entrprise) {
        current_category.value = "Solutions";
      }
      current_solution_name.value = solutions.value[0].name;

      //@ts-ignore
      if (props.modalData) {
        //@ts-ignore
        if (props.modalData.current) {
          // @ts-ignore
          current_category.value = props.modalData.current;
        }
        // @ts-ignore
        if (props.modalData.solution) {
          // @ts-ignore
          current_solution_name.value = props.modalData.solution;
        }
      }
    });

    const isStartedTrail = ref(false);
    const countdown = ref(5);

    const start_the_trial = async () => {
      AppAnalytics.report({
        component: "Upgrade",
        eventName: "start_standard_trial_clicked",
      });
      await startTrial();
      isStartedTrail.value = true;
      // @ts-ignore
      window.show_confetti();
      const id = setInterval(() => {
        if (countdown.value === 0) {
          const url = location.href + "?firsttime=true";
          window.open(url, "_self");
          clearInterval(id);
        } else {
          countdown.value--;
        }
      }, 1000);
    };

    const show_trial_btn = computed(
      () =>
        !SharedState.loggedUser.value.trial.exhausted &&
        !SharedState.loggedUser.value.trial.active &&
        editionToNumber(SharedState.paymentEdition.value.name) <
          editionToNumber("standard")
    );

    return {
      show_trial_btn,
      countdown,
      isStartedTrail,
      start_the_trial,
      current_solution_name,
      current_category,
      current_solution,
      solutions,
      main_tabs,
      has_many_solutions,
      config,
      plans,
    };
  },
});
